import React from "react";
import "../style/loader.css";

function Spinner(props) {
  return (
    <div className="spinner-container">
      <div className="loader" style={props.style}>
        <img 
          src={require("../images/site-logo.png")} 
          alt="Loader" 
          className="loader-img"
        />
      </div>
    </div>
  );
}

export default Spinner;